import { Calendar, MessageCircle } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { useLocalizedPath } from "@/hooks/useLocalizedPath";

/**
 * Sticky mobile CTA bar at the bottom of the screen.
 * Shows "Book Now" and "WhatsApp" buttons on mobile only (hidden on md+).
 */
export default function MobileCTABar() {
  const { language } = useLanguage();
  const { lp } = useLocalizedPath();

  const phoneNumber = "34627183220";
  const messages: Record<string, string> = {
    es: "Hola%20Dra.%20Raquel%20Molina%2C%20me%20gustar%C3%ADa%20programar%20una%20consulta.",
    en: "Hello%20Dr.%20Raquel%20Molina%2C%20I%20would%20like%20to%20schedule%20a%20consultation.",
    sv: "Hej%20Dr.%20Raquel%20Molina%2C%20jag%20skulle%20vilja%20boka%20en%20konsultation.",
  };

  const labels: Record<string, { book: string; whatsapp: string }> = {
    es: { book: "Reservar Cita", whatsapp: "WhatsApp" },
    en: { book: "Book Now", whatsapp: "WhatsApp" },
    sv: { book: "Boka Nu", whatsapp: "WhatsApp" },
  };

  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${messages[language]}`;
  const bookingPath = lp("/booking");
  const t = labels[language] || labels.es;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden">
      {/* Gradient fade above the bar for smooth visual transition */}
      <div className="h-2 bg-gradient-to-t from-white/90 to-transparent pointer-events-none" />
      <div className="bg-white/95 backdrop-blur-sm border-t border-gray-200 px-4 py-3 flex gap-3 shadow-[0_-4px_12px_rgba(0,0,0,0.08)]">
        <a
          href={bookingPath}
          className="flex-1 flex items-center justify-center gap-2 bg-teal-600 hover:bg-teal-700 text-white font-semibold py-3 px-4 rounded-lg transition-colors text-sm"
        >
          <Calendar className="h-4 w-4 shrink-0" />
          <span>{t.book}</span>
        </a>
        <a
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="flex-1 flex items-center justify-center gap-2 bg-green-500 hover:bg-green-600 text-white font-semibold py-3 px-4 rounded-lg transition-colors text-sm"
        >
          <MessageCircle className="h-4 w-4 shrink-0" />
          <span>{t.whatsapp}</span>
        </a>
      </div>
    </div>
  );
}
